import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-sales-order-deliver-fee-dialog',
  templateUrl: './sales-order-deliver-fee-dialog.component.html',
  styleUrls: ['./sales-order-deliver-fee-dialog.component.scss']
})
export class SalesOrderDeliverFeeDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<SalesOrderDeliverFeeDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      km: [null, Validators.compose([Validators.required, Validators.min(0), Validators.max(10000)])],
    });
  }

  ngOnInit() {

  }

  save() {
    this.baseService.executeCommand<any[]>('portal_sales_order_header_add_delivery_fee', {
      salesOrderHeaderId: this.data.salesOrderHeaderId,
      km: this.form.value.km,
    })
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(true);
        }
      });
  }
}
